import Text from 'components/3catinfo/Text';
import styles from '../cosNoticia.module.scss';

const TextNoti = (props) => {
    const { text } = props;

    return <Text text={text} dataTestId='cos-noticia-text' className={styles.textNoti} />;
};

export default TextNoti;
